import CacheUtil from "../../../../../shared/lib/html5-software-library/src/ranj/util/CacheUtil";
import GameConfig from "../model/GameConfig";

export default class GameElementSkinFactory {

    /**
     * @param {GameConfig} gameConfig 
     * @param {Object} assets 
     */
    constructor(gameConfig, levelAssets) {
        this._gameConfig = gameConfig;
        this._assets = levelAssets;
    }

    getItem(index) {
        const skinName = this._gameConfig.getItemName(index);
        return new this._assets[skinName]();
    }

    getLocation(index) {
        const skinName = this._gameConfig.getLocationSkin(index);
        return new this._assets[skinName]();
    }

    getLocationBounds(index) {
        const loc = this._gameConfig.getLocation(index);
        return new createjs.Rectangle(0, 0, loc.width, loc.height);
    }

}
